import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { mapStringToCurrencySymbol } from '../../mappers/common/common';
import { Bem } from '../../service/Bem/Bem';
import { ErrorItemText } from '../ErrorsPresenter/ErrorsPresenter';
import { TextInputDecorator } from '../TextInputDecorator/TextInputDecorator';

import './PhrasePriceEditor.css';
import * as keyset from './PhrasePriceEditor.i18n';

const i18n = i18nFactory(keyset);

export interface PhrasePriceEditorProps {
    error?: ErrorItemText;
    price?: string;
    onChange: (val: string) => void;
    currency: string;
}

export class PhrasePriceEditor extends React.Component<
    PhrasePriceEditorProps,
    {}
> {
    render() {
        const { error, price, onChange, currency } = this.props;

        return (
            <div className={'phrase-price-editor'}>
                <div
                    className={Bem.cls('phrase-price-editor', 'price-content')}
                >
                    <TextInputDecorator
                        theme="normal"
                        size="m"
                        view="classic"
                        cls={Bem.cls('phrase-price-editor', 'money-input')}
                        valid={!error}
                        text={price}
                        autoFocus={true}
                        onChange={onChange}
                    />

                    <span
                        className={Bem.cls('phrase-price-editor', 'currency')}
                    >
                        {mapStringToCurrencySymbol(currency)}
                    </span>
                    <div className={Bem.cls('phrase-price-editor', 'hint')}>
                        {i18n('adjustments-rate')}
                    </div>
                </div>

                <div className={Bem.cls('phrase-price-editor', 'error')}>
                    {error}
                </div>
            </div>
        );
    }
}
